// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-rules-header {
  height: 7%;
  background-color: #17A2B8;
  color: white;
  display: flex;
  align-items: center;
  padding-left: 1%;
}

.header {
  width: 97%;
  font-size: 14px;
  font-weight: bold;
}

.custom-rules-body {
  height: 83%;
  overflow: auto;
}

.custom-rules-footer {
  display: flex;
  height: 10%;
  justify-content: flex-end;
}

.parameters {
  height: 80%;
}

.method-type-rule-name {
  height: 20%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #E8FCFF;
  padding: 1%;
  border-bottom: 1px solid #17A2B8;
}

.select-methodname {
  width: 98%;
  margin: 1%;
}

.field {
  padding: 1%;
}

.rule-name-field {
  width: 98%;
  margin: 1%;
}

:host ::ng-deep .mat-mdc-form-field {
  background-color: #fff !important;
}
:host ::ng-deep .mat-mdc-autocomplete-panel {
  background-color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-config-component/custom-rules/custom-rules.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,WAAA;EACA,cAAA;AACJ;;AACA;EACI,aAAA;EACA,WAAA;EACA,yBAAA;AAEJ;;AAAA;EACK,WAAA;AAGL;;AADA;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,gCAAA;AAIJ;;AAFA;EACI,UAAA;EACA,UAAA;AAKJ;;AAHA;EACI,WAAA;AAMJ;;AAJA;EACI,UAAA;EACA,UAAA;AAOJ;;AAHI;EACI,iCAAA;AAMR;AAHI;EACI,iCAAA;AAKR","sourcesContent":[".custom-rules-header {\r\n    height: 7%;\r\n    background-color: #17A2B8;\r\n    color: white;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 1%;\r\n}\r\n\r\n.header {\r\n    width: 97%;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n}\r\n\r\n.custom-rules-body{\r\n    height: 83%;\r\n    overflow: auto;\r\n}\r\n.custom-rules-footer{\r\n    display: flex;\r\n    height: 10%;\r\n    justify-content: flex-end;\r\n}\r\n.parameters{\r\n     height: 80%;\r\n}\r\n.method-type-rule-name{\r\n    height: 20%;    \r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: #E8FCFF;\r\n    padding: 1%;\r\n    border-bottom: 1px solid #17A2B8;\r\n}\r\n.select-methodname{\r\n    width: 98%;\r\n    margin: 1%;\r\n}\r\n.field{\r\n    padding: 1%;\r\n}\r\n.rule-name-field{\r\n    width: 98%;\r\n    margin:1%;\r\n}\r\n\r\n:host ::ng-deep {\r\n    .mat-mdc-form-field {\r\n        background-color: #fff !important;\r\n    }\r\n    \r\n    .mat-mdc-autocomplete-panel {\r\n        background-color: #fff !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
